export const groupCargasByAlmacenBulto = (cargas) => {
    if (!cargas || !Array.isArray(cargas)) {
        return [];
    }

    const grouped = cargas.reduce((acc, item) => {
        if (!item.almacen || !item.almacen.id) {
            return acc;
        }

        const almacenId = item.almacen.id;
        const bultoId = item.bulto_skim ? item.bulto_skim.id : "sin_bulto";

        // llave única
        const key = `${almacenId}-${bultoId}`;

        if (!acc[key]) {
            acc[key] = {
                almacen: item.almacen,
                bulto_skim: item.bulto_skim || null,

                kg_humedos: 0,
                kg_secos: 0,

                // para promedio ponderado de drc
                total_drc_ponderado: 0,
                total_kg_drc: 0,

                cargas_ids: [],
                items: [],
            };
        }

        const kgHumedos = Number(item.kg_humedos) || 0;
        const drc = Number(item.drc) || 0;
        const kgSecos = Number(item.kg_secos) || 0;

        acc[key].kg_humedos += kgHumedos;
        acc[key].kg_secos += kgSecos;

        // acumulado para promedio ponderado
        if (item.drc !== null && item.drc !== undefined) {
            acc[key].total_drc_ponderado += kgHumedos * drc;
            acc[key].total_kg_drc += kgHumedos;
        }

        acc[key].cargas_ids.push(item.id);
        acc[key].items.push(item);

        return acc;
    }, {});

    return Object.values(grouped).map((grupo) => {
        return {
            ...grupo,

            // TODO: Tal vez podamos encontrar un mejor criterio que sacar promedios
            drc:
                grupo.total_kg_drc > 0
                    ? grupo.total_drc_ponderado / grupo.total_kg_drc
                    : null,
        };
    });
};
